import {
  ArticleData,
  HomepageContent,
  ResourcesSection,
  SectionId,
} from '@wix/wix-help-widget-common/homepage';

import { assertUnreachable } from '../guards';
import { BlockId, blockNames, BlockType, SupportType } from './helpCenter';
import { SolutionInfo } from './types';

export function getHomepageSolutionInfo(
  homepageContent: HomepageContent,
  recommendedArticles: ArticleData[] | null,
): SolutionInfo[] {
  return homepageContent.sections.map((section, i) => {
    switch (section.sectionId) {
      case SectionId.Articles:
        return {
          block_id: BlockId.RecommendedArticle,
          block_name: blockNames[BlockId.RecommendedArticle],
          block_position: i + 1,
          block_type: BlockType.Solution,
          block_details: (recommendedArticles || []).map((item, index) => ({
            support_type: SupportType.Article,
            support_id: item.id,
            support_position: index + 1,
          })),
        };
      case SectionId.HelpCenter:
        return {
          block_id: BlockId.HelpCenter,
          block_name: blockNames[BlockId.HelpCenter],
          block_position: i + 1,
          block_type: BlockType.Link,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Link,
            },
          ],
        };
      case SectionId.ContactUs:
        return {
          block_id: BlockId.ContactUsButton,
          block_name: blockNames[BlockId.ContactUsButton],
          block_position: i + 1,
          block_type: BlockType.Button,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Button,
            },
          ],
        };
      case SectionId.ChatWithUs:
        return {
          block_id: BlockId.ChatWithUs,
          block_name: blockNames[BlockId.ChatWithUs],
          block_position: i + 1,
          block_type: BlockType.Link,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Link,
            },
          ],
        };
      case SectionId.HirePartner:
        return {
          block_id: BlockId.HirePartnerButton,
          block_name: blockNames[BlockId.HirePartnerButton],
          block_position: i + 1,
          block_type: BlockType.Button,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Button,
            },
          ],
        };
      case SectionId.ShareFeedback:
        return {
          block_id: BlockId.ReportABugButton,
          block_name: blockNames[BlockId.ReportABugButton],
          block_position: i + 1,
          block_type: BlockType.Button,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Button,
            },
          ],
        };
      case SectionId.Resources:
        return {
          block_id: BlockId.Resources,
          block_name: blockNames[BlockId.Resources],
          block_position: i + 1,
          block_type: BlockType.Link,
          block_details: (section as ResourcesSection).items?.map(
            (item, index) => ({
              support_type: SupportType.Link,
              support_id: `${item.resourceId}`,
              support_position: index + 1,
            }),
          ),
        };
      case SectionId.StatusPage:
        return {
          block_id: BlockId.StatusPage,
          block_name: blockNames[BlockId.StatusPage],
          block_position: i + 1,
          block_type: BlockType.Link,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Link,
            },
          ],
        };
      case SectionId.UserContacts:
        return {
          block_id: BlockId.UserContacts,
          block_name: blockNames[BlockId.UserContacts],
          block_position: i + 1,
          block_type: BlockType.Button,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Button,
            },
          ],
        };
      case SectionId.RequestSuccessManager:
        return {
          block_id: BlockId.RequestSuccessManager,
          block_name: blockNames[BlockId.RequestSuccessManager],
          block_position: i + 1,
          block_type: BlockType.Button,
          block_details: [
            {
              support_id: null,
              support_position: 1,
              support_type: SupportType.Button,
            },
          ],
        };
      default:
        return assertUnreachable(section.sectionId);
    }
  });
}
